import { useState, useEffect } from "react";
import { FormRow, FormRowSelect, NavLinkButton } from "../components";
import Wrapper from "../assets/wrappers/DashboardFormPage";
import { customFetch } from "../utils/custom-fetch.js";
import {
  useLoaderData,
  useNavigate,
  Link,
  Form,
  redirect,
} from "react-router-dom";
import { toast } from "react-toastify";

export const action = async ({ request }) => {
  const formData = await request.formData();

  // שליפת ערכים מהטופס
  const selectionType = formData.get("isPublic");

  formData.append('applyToAllBuildings', 'true');

  let query = "/buildings";
  let buildings = [];

  // קבלת נתוני הבניינים על פי סוג הבחירה
  if (selectionType === "לכל הבניינים") {
    buildings = await customFetch.get(query);
  } else {
    const city = formData.get("city");
    const street = formData.get("street");
    const buildingNumber = formData.get("buildingNumber");

    if (city && city !== "כל הערים")
      query += `?city=${encodeURIComponent(city)}`;
    if (street && street !== "כל הרחובות")
      query += `${city ? "&" : "?"}street=${encodeURIComponent(street)}`;
    if (buildingNumber && buildingNumber !== "כל הבניינים")
      query += `${
        city || street ? "&" : "?"
      }buildingNumber=${encodeURIComponent(buildingNumber)}`;

    buildings = await customFetch.get(query);
  }

  const { data } = buildings;
  const ids = data.buildings.map((building) => building._id);
  // // בדוק אם הבניינים מכילים IDs תקינים
  // const validBuildings = buildings.filter(
  //   (building) => building._id && /^[0-9a-fA-F]{24}$/.test(building._id)
  // );
  // if (validBuildings.length !== buildings.length) {
  //   console.error('נמצאו מזהים לא תקינים בין הבניינים');
  //   return null;
  // }

  // // // הוספת הבניינים שנבחרו ל-FormData
  // formData.append('buildings', JSON.stringify(validBuildings));

  try {
    // // שליחת בקשת PATCH לשרת עם הקובץ והבניינים
    const response = await customFetch.patch("/buildings/addMedia", formData);

    if (!response.ok) {
      throw new Error("Failed to upload media");
    }

    toast.success("המדיה הועלתה בהצלחה!");
    return redirect("/dashboard/all-buildings");
  } catch (error) {
    console.error("Error uploading media:", error);
    toast.error("שגיאה בהעלאת המדיה.");
    return null;
  }
};

const AddMedia = () => {
  const { data } = useLoaderData();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [isPublic, setIsPublic] = useState("לכל הבניינים");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedStreet, setSelectedStreet] = useState("");
  const [selectedBuildingNumber, setSelectedBuildingNumber] = useState("");
  const [cities, setCities] = useState([]);
  const [streets, setStreets] = useState([]);
  const [buildingNumbers, setBuildingNumbers] = useState([]);

  useEffect(() => {
    const uniqueCities = [
      "כל הערים",
      ...new Set(data.buildings.map((item) => item.city)),
    ];
    setCities(uniqueCities);
  }, [data]);

  useEffect(() => {
    if (selectedCity && selectedCity !== "כל הערים") {
      const uniqueStreets = [
        "כל הרחובות",
        ...new Set(
          data.buildings
            .filter((item) => item.city === selectedCity)
            .map((item) => item.street)
        ),
      ];
      setStreets(uniqueStreets);
    } else {
      setStreets([]);
      setSelectedStreet(""); // Clear street selection
    }
    setSelectedBuildingNumber(""); // Clear building number selection
  }, [selectedCity, data]);

  useEffect(() => {
    if (selectedStreet && selectedStreet !== "כל הרחובות") {
      const uniqueBuildings = [
        "כל הבניינים",
        ...new Set(
          data.buildings
            .filter((item) => item.street === selectedStreet)
            .map((item) => item.houseNumber.toString())
        ),
      ];
      setBuildingNumbers(uniqueBuildings);
    } else {
      setBuildingNumbers([]);
      setSelectedBuildingNumber("");
    }
  }, [selectedStreet, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "file":
        setFile(value);
        break;
      case "isPublic":
        setIsPublic(value);
        setSelectedCity("");
        setSelectedStreet("");
        setSelectedBuildingNumber("");
        break;
      case "city":
        setSelectedCity(value);
        break;
      case "street":
        setSelectedStreet(value);
        break;
      case "buildingNumber":
        setSelectedBuildingNumber(value);
        break;
      default:
        break;
    }
  };

  return (
    <Wrapper className="full-page">
      <Form method="post" className="form">
        <h4 className="form-title">הוספת מדיה גלובלית</h4>
        <div className="form-center">
          <FormRow
            type="file"
            name="file"
            labelText="בחר קובץ"
            handleChange={handleChange}
            isRequired={true}
          />
          <FormRowSelect
            labelText="מדיה ציבורית"
            name="isPublic"
            value={isPublic}
            handleChange={handleChange}
            list={["לכל הבניינים", "בחירת בניינים"]}
          />

          <input
            type="hidden"
            name="applyToAllBuildings"
            value={isPublic === "לכל הבניינים" ? "true" : "false"}
          />

          {isPublic === "בחירת בניינים" && selectedCity !== "כל הערים" && (
            <>
              <FormRowSelect
                labelText="בחר עיר"
                name="city"
                value={selectedCity}
                handleChange={handleChange}
                list={cities}
                placeholder="בחר עיר"
              />
              {selectedCity && selectedStreet !== "כל הרחובות" && (
                <FormRowSelect
                  labelText="בחר רחוב"
                  name="street"
                  value={selectedStreet}
                  handleChange={handleChange}
                  list={streets}
                  placeholder="בחר רחוב"
                />
              )}
              {selectedStreet && (
                <FormRowSelect
                  labelText="בחר מספר בניין"
                  name="buildingNumber"
                  value={selectedBuildingNumber}
                  handleChange={handleChange}
                  list={buildingNumbers}
                  placeholder="בחר מספר בניין"
                />
              )}
            </>
          )}
          <div className="btn-container">
            <button type="submit" className="btn btn-block form-btn">
              שמירה
            </button>
            <NavLinkButton text="ביטול" path="/dashboard/all-buildings" />
          </div>
        </div>
      </Form>
    </Wrapper>
  );
};

export default AddMedia;
